import getEntryNumbers from '@/libs/getEntryNumbers'
import TransferAsk from '@/components/TransferAsk'
import TransferConfirm from '@/components/TransferConfirm'
import { VOICE_CHANNEL } from '@/constants/channels'

export const confirmTransfer = (vm, entryNumber, call) => (
  vm.$q.dialog({
    call,
    parent: vm,
    component: TransferConfirm,
    entryNumber
  }).onOk(() => {
    const sessionId = call.id
    vm.$store.dispatch('attendanceModule/updateOptionCallback', { callTransferred: true }, { root: true })
    vm.$store.dispatch('sipModule/transferEntryNumber', { sessionId, entryNumber })
  })
)

export const askTransfer = async (vm, contact) => {
  const entryNumber = await getEntryNumber(contact)
  if (!entryNumber) return false

  const ongoingCalls = getOngoingCalls(vm)
  if (!ongoingCalls.length) return false

  return vm.$q.dialog({
    parent: vm,
    component: TransferAsk,
    entryNumber
  }).onOk(({ action, sessionId }) => {
    if (action === 'TRANSFER') return vm.$store.dispatch('sipModule/transferEntryNumber', { sessionId, entryNumber })
    if (action === 'CALL') return vm.$store.dispatch('sipModule/call', contact)
  })
}

const getEntryNumber = async (contact) => {
  const entryNumbers = await getEntryNumbers(false)

  return entryNumbers.find((item) => {
    const number = item.destinationType === 'AGENTCODE' ? `*20*${item.number}` : item.number
    return number === contact
  })
}

const getOngoingCalls = (vm) => {
  const attendances = Object.values(vm.$store.state.attendanceModule.current ?? {})
  return attendances.filter(({ channel }) => channel === VOICE_CHANNEL)
}

export const entryNumberType = (entryNumber) => {
  const { destinationType } = entryNumber ?? {}
  if (destinationType === 'URA') return 'URA'
  if (destinationType === 'QUEUE') return 'Fila'
  if (destinationType === 'AGENT') return 'Agente'
  if (destinationType === 'AGENTCODE') return 'Agente'
  if (destinationType === 'EXTENSION') return 'Ramal'
  if (destinationType === 'EXTERNAL') return 'Externo'
  return destinationType ?? ''
}
